import { useQualtricsSurvey } from '@cae/cobalt-react/hooks/use-qualtrics-survey';
import { useAuthenticatedUser } from '@contexts/auth-provider';
import { useOrganizations } from '@contexts/organizations-provider';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { QUALTRICS_ZONE_ID } from './useQualtricsInitializer.constants';

/**
 * Initializes the Qualtrics survey intercept.
 *
 * Call once inside AppLayout so it activates only when the user is fully
 * authenticated, has permissions, and the main shell is rendered.
 *
 * Triggers on every route change so Qualtrics can evaluate its own
 * display-frequency / targeting rules with up-to-date page context.
 */
export function useQualtricsInitializer(): void {
  const location = useLocation();
  const { id, email, firstName, lastName } = useAuthenticatedUser();
  const { selectedOrganization } = useOrganizations();

  const { triggerSurvey } = useQualtricsSurvey({
    zoneId: QUALTRICS_ZONE_ID,
  });

  useEffect(() => {
    triggerSurvey({
      UserEmail: email,
      UserRole: selectedOrganization?.roles?.[0] ?? '',
      UserFirstName: firstName,
      UserLastName: lastName,
      UserId: id,
      CurrentPage: location.pathname,
      UserCompanyId: selectedOrganization?.id ?? '',
      UserCompanyName: selectedOrganization?.name ?? '',
    });
  }, [
    triggerSurvey,
    email,
    firstName,
    lastName,
    id,
    location.pathname,
    selectedOrganization?.roles,
    selectedOrganization?.id,
    selectedOrganization?.name,
  ]);
}
